var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-group" }, [
    _vm.label
      ? _c("label", { staticClass: "font-size-12" }, [
          _vm._v(_vm._s(_vm.label)),
        ])
      : _vm._e(),
    _c("div", { staticClass: "input-container d-flex" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.iValue,
            expression: "iValue",
          },
        ],
        staticClass: "form-control",
        style: { flex: "1 1 auto" },
        attrs: {
          disabled: _vm.loadingUpload,
          type: "text",
          placeholder: "https://example.com",
        },
        domProps: { value: _vm.iValue },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.iValue = $event.target.value
          },
        },
      }),
      _c(
        "button",
        {
          staticClass: "btn-upload",
          attrs: { disabled: _vm.loadingUpload, title: "Upload" },
          on: { click: _vm.selectFile },
        },
        [
          _vm.loadingUpload
            ? _c("b-spinner", { attrs: { small: "" } })
            : _c("i", { class: _vm.uploadIcon }),
        ],
        1
      ),
      _c(
        "button",
        {
          staticClass: "btn-upload btn-remove",
          attrs: { disabled: _vm.loadingUpload, title: "Delete" },
          on: { click: _vm.removeImage },
        },
        [_c("i", { class: _vm.deleteIcon })]
      ),
      _c("input", {
        ref: "inputFile",
        style: { display: "none" },
        attrs: { type: "file", name: "upload", accept: "image/*" },
        on: {
          change: function ($event) {
            return _vm.uploadFile($event)
          },
        },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }